import { render, staticRenderFns } from "./FaizOranForm.vue?vue&type=template&id=517411a4"
import script from "./FaizOranForm.vue?vue&type=script&lang=ts"
export * from "./FaizOranForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports